import { Link } from 'react-router-dom'
import { Head } from 'vite-react-ssg'
import { SITE } from '../lib/site'

export interface Crumb {
  name: string
  href: string
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((c, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: c.name,
      item: SITE.url + c.href,
    })),
  }
  return (
    <nav aria-label="Breadcrumb" className="mb-3 text-sm text-text-muted">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((c, i) => (
          <li key={c.href} className="flex items-center gap-1.5">
            {i > 0 && <span aria-hidden className="text-text-subtle">›</span>}
            {i < items.length - 1 ? (
              <Link to={c.href} className="hover:text-brand-text">
                {c.name}
              </Link>
            ) : (
              <span aria-current="page" className="text-text">
                {c.name}
              </span>
            )}
          </li>
        ))}
      </ol>
      <Head>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Head>
    </nav>
  )
}
